import { CreateJob } from "~/types/jobs";
import { StringRecord } from "~/types/record";
import React, { Dispatch, SetStateAction } from "react";
import GoogleMapsInput from "src/shared/GoogleMapsInput";
import { FullAddress } from "~/shared/GoogleMapsInput/types";
import TextInput from "~/shared/TextInput";
import TextareaInput  from "~/shared/TextareaInput";
import MaskedInput from "~/shared/MaskedInput";
import axios from "axios";
import { toast } from "react-toastify";

type JobKeyAddressSectionProps = {
    fields: Partial<CreateJob>;
    errors: StringRecord;
    handleChange: (name: string, value: any) => void;
    handleBlur: (name: string, value: any) => void;
    setJobKeyInOtherPlace: Dispatch<SetStateAction<"sim" |"nao">>
    jobKeyInOtherPlace: "sim" |"nao"
};

const JobKeyAddressSection = ({fields, errors, handleBlur, handleChange,  setJobKeyInOtherPlace, jobKeyInOtherPlace}:JobKeyAddressSectionProps) => {

    const findCep = async (_: string, value: string) => {
        try {
            const response = await axios.get(`https://api.pagar.me/1/zipcodes/${value}`);
           console.log({response: response.data})

            handleChange("jobKeyAddress", response.data.street);
            handleChange("jobKeyNeighborhood", response.data.neighborhood);
            handleChange("jobKeyCity", response.data.city);
            handleChange("jobKeyUf", response.data.state);
        } catch (error) {
            return toast.error("CEP não encontrado");
        }
    };

    const handleAddressChange = (_: string, value: FullAddress) => {
        handleChange("jobKeyAddress", value.fullAddress);
        handleChange("jobKeyNumber", value.number);
        handleChange("jobKeyComplement", value.complement);
        handleChange("jobKeyNeighborhood", value.neighborhood);
        handleChange("jobKeyZipCode", value.zipCode);
        handleChange("jobKeyCity", value.cityName);
        handleChange("jobKeyUf", value.uf);
    };

    const handleAddressBlur = (_: string, value: FullAddress) => {
        handleBlur("jobKeyAddress", value.address);
        handleBlur("jobKeyNumber", value.number);
        handleBlur("jobKeyComplement", value.complement);
        handleBlur("jobKeyNeighborhood", value.neighborhood);
        handleBlur("jobKeyZipCode", value.zipCode);
        handleBlur("jobKeyCity", value.cityName);
        handleBlur("jobKeyUf", value.uf);

    };

    return (
        <div style={{margin: "0.5rem 0"}}>
                <div style={{display: "flex", alignItems:"center"}} >
                    <input
                        type="checkbox"
                        checked={jobKeyInOtherPlace === "sim" }
                        onChange={e => setJobKeyInOtherPlace(e.target.checked ? "sim" : "nao")}
                    />
                    <small style={{marginLeft: "0.5rem"}}>
                        Chave da sessão fotográfica encontra-se em outro lugar?
                    </small>
                </div>
            <div className="mt-2">
                {jobKeyInOtherPlace === "sim" ? (
                    <>
                        <div className="row">
                        <div className="col-md-6 col-12">
                                <GoogleMapsInput
                                    autoComplete="chrome-off"
                                    label="Endereço do local da chave"
                                    name="jobKeyAddress"
                                    value={fields.jobKeyAddress}
                                    handleChange={handleAddressChange}
                                    handleBlur={handleAddressBlur}
                                    error={errors.jobKeyAddress}
                                />
                            </div>

                            <div className="col-md-3 col-6">
                                <TextInput
                                    autoComplete="off"
                                    label="Número"
                                    placeholder="Número"
                                    name="jobKeyNumber"
                                    maxLength={20}
                                    value={fields.jobKeyNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.jobKeyNumber}
                                />
                            </div>

                            <div className="col-md-3 col-6">
                                <TextInput
                                    autoComplete="off"
                                    label="Complemento"
                                    value={fields.jobKeyComplement}
                                    placeholder="Complemento"
                                    name="jobKeyComplement"
                                    maxLength={50}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.jobKeyNumber}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3 col-6">
                                <MaskedInput
                                    autoComplete="off"
                                    mask={[/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/]}
                                    guide={false}
                                    name="jobKeyZipCode"
                                    label="CEP"
                                    placeholder="CEP"
                                    value={fields.jobKeyZipCode || ""}
                                    onChange={handleChange}
                                    onBlur={(name: string, value: string) => {
                                        findCep(name, value);
                                        handleBlur(name, value);
                                    }}
                                    error={errors.jobKeyNumber}
                                />
                            </div>

                            <div className="col-md-3 col-6">
                                <TextInput
                                    autoComplete="off"
                                    label="Bairro"
                                    placeholder="Bairro"
                                    name="jobKeyNeighborhood"
                                    maxLength={100}
                                    value={fields.jobKeyNeighborhood}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.jobKeyNumber}
                                />
                            </div>
                            <div className="col-12">
                                <TextareaInput
                                    autoComplete="off"
                                    label="Observacão do local da chave"
                                    placeholder=""
                                    name="jobKeyAddressObs"
                                    rows={4}
                                    value={fields.jobKeyAddressObs}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.jobKeyAddressObs}
                                />
                            </div>

                        </ div>
                    </>
                ) : ""}
            </div>
        </div>
    )
}

export default JobKeyAddressSection
